




























































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { Toast } from 'vant'; 
import { TbGoodsClass, TbGrade, TbMember, TbSettings, TbSettingsPad } from "@/http";
import dialogPanel from "./dialogPanel.vue";
import dayjs from 'dayjs';
import {PrintLabelEvent1,PrintLabelEvent2} from "@/common/util/prints";
import { TbShopLabelTemplate } from '@/http/api_TbShopLabelTemplate';
import { TbShop } from '@/http/api_TbShop';
const { userAgent } = navigator;
const isAndroid = userAgent.indexOf('Android') > -1 ||userAgent.indexOf('android') > -1 || userAgent.indexOf('Adr') > -1;; // android终端
 @Component({
    components: {dialogPanel},
}) 
export default class printLabelPanel extends Vue {
   
    public $refs!: {
       
    };

    @Prop({
        default:false
    })
    show:Boolean;

    @Prop({
        type:Object,
        default:()=>{
            return{
                list:[]
            }
        }
    })
    form:any;

    config={
        loop : [
            {
                number : 1,
                key : 'number-1',
            },
            {
                number : 2,
                key : 'number-2',
            },
            {
                number : 3,
                key : 'number-3',
            },
            {
                number : 4,
                key : 'number-4',
            },
            {
                number : 5,
                key : 'number-5',
            },
            {
                number : 6,
                key : 'number-6',
            },
            {
                number : 7,
                key : 'number-7',
            },
            {
                number : 8,
                key : 'number-8',
            },
            {
                number : 9,
                key : 'number-9',
            },
        ]
    }

    value=null;
    maxLength=4;
    userInfo:any={};
    shopInfo:any={};
    list = [];
    checkedAll = false;
    editIndex = null;

    isPrintLoading = false;

    pageSize = 1;
    

    async mounted() {
        this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
        this.shopInfo = JSON.parse(localStorage.getItem("padShopInfo"));
        this.checkedAll = true;
        this.list = this.form.getGoodsItemsList.map(v=>{
            return{
                ...v,
                checked:true,
                num:v.stock>0?v.stock:0
            }
        });

    }

    
    async created() {
    
    }

    async saveFun(val){
       
        
    }

    
  
    closeFun(){
        this.$emit("closeFun");
    }


    del() {
		if(!this.value) return;
            let index = this.value.length;
            this.value = this.value.toString().slice(0,index-1);
            this.finishFun(this.value,this.editIndex);
        }
	number(number) {
		// this.$emit("number", number);
		let val = this.value;
		let dotIndex = this.value?this.value.toString().indexOf('.'):-1;
		if(number=='.'&&dotIndex>-1||this.value&&this.value.toString().length==this.maxLength) return;
		this.value = this.value?this.value.toString() + number.toString():number.toString();
		if(dotIndex>-1){
			if(val.toString().slice(dotIndex+1).length>1){
				this.value = this.value.slice(0,dotIndex+3)
			}
		}else{
			this.value = this.value.slice(0,this.maxLength)
		}
		this.finishFun(this.value,this.editIndex);
	}


	clearFun(){
            this.value = null;
            this.finishFun(this.value,this.editIndex);
    }
    finishFun(val,index){
        this.$set(this.list[index],'num',val)
    }

    minusFun(item,index){
        let val = item.num;
        this.editIndex = index;
        if(!item.num||Number(item.num)==0) return;
        val--;
        this.finishFun(val,index);
    }
    addFun(item,index){
        this.editIndex = index;
        let val = item.num;
        if(Number(val)==9999) return;
        if(!val){
            val=1
        }else{
            val++;
        }
        this.finishFun(val,index);
    }

    setNumVal(val,index){
        this.value = val;
        this.editIndex = index;
    }

    async printTest(){
    if(this.list.filter(v=>v.checked&&Number(v.num)>0).length==0){
        Toast("请选择标签");
        return;
    }
    let printList = this.list.filter(v=>v.checked&&Number(v.num)>0).map(v=>{
        return{
            articleNo:this.form.articleNo,
            goodsSpecsName:v.goodsSpecsName,
            name:this.form.name,
            barCode:v.barCode,
            goodsClassName:this.form.goodsClassName,
            safetyLevel:this.form.safetyLevel,
            material:this.form.material,
            qualityLevel:this.form.qualityLevel,
            washingMethod:this.form.washingMethod,
            shopName:this.shopInfo.shopName,
            sellingPrice: this.form.sellingPrice.toString(),
            number:v.num,
            standard: this.form.standard,
            supplierName: this.form.supplierName,
            shortBarCode:v.shortBarCode,
            discountPrice:this.form.discountPrice,
            memberPriceRange:this.form.memberPriceRange,
            goodsDesc:this.form.goodsDesc,
            isMemberDiscount:this.form.isMemberDiscount,
            washStr1:"",
            washStr2:"",
        }
    });
    if(this.isPrintLoading)return;
    this.isPrintLoading = true;
    let resSetting= null;
     let resShop = await TbShop.GetInitShopInfo({shopid:this.shopInfo.id});
     let isnewLabel = resShop.webShopLabelTemplateType;   
     if(isnewLabel==0){
         if(localStorage.getItem('labelPaperSize')){
             let val =Number(localStorage.getItem('labelPaperSize'));
             if(this.userInfo['isJewelry']){
                 this.pageSize = 3;
             }else{
                 this.pageSize = val;
             }
         }else{
             if(this.userInfo['isJewelry']){
                 this.pageSize = 3;
             }else{
                 this.pageSize = 1;
             }
         }
             if(this.pageSize==1){
                 resSetting = await TbSettingsPad.GetTbSettings({settingtype:7})
             }else if(this.pageSize==2){
                 resSetting = await TbSettingsPad.GetTbSettings({settingtype:10})
             }else{
                 resSetting = await TbSettingsPad.GetTbSettings({settingtype:12})
             }
             let size = this.pageSize;
             
             
             let time = 3000*resSetting.settingContent.putNum
             setTimeout(()=>{
             this.isPrintLoading = false;
             this.closeFun();
             },time)
             printList.forEach(v=>{
                let form = Object.assign({},{settingContent:resSetting.settingContent},{orderInfoArr:[v]},{type:'label'},{paperSize:Number(size)})
                PrintLabelEvent1(form,resSetting.settingContent.putNum)
             })
     }else{
        let res = await TbShopLabelTemplate.GetShopLabelTemplateList({ shopno:this.shopInfo.shopNo,
                            shopid:this.shopInfo.id,skip:0,count:1});
            if(res.items.length>0){
                let newTemplateId = res.items[0].id;
                let res2 = await TbShopLabelTemplate.GetTbShopLabelTemplateById({id:newTemplateId});
                let padSetInfo =res2;
                let putNum = res2.contentJson.labelTemplateMore.printNum;
                let time = 3000*putNum;
                setTimeout(()=>{
                    this.isPrintLoading = false;
                     this.closeFun();
                },time)
                printList.forEach(v=>{
                    let form = Object.assign({},{settingContent:padSetInfo},{orderInfoArr:[v]},{type:'label'},{paperSize:padSetInfo.labelTemplateType})
                    PrintLabelEvent2(form,putNum,false)
                })
            }
     }
  }

  checkAllFun(){
    
    this.list = this.list.map(v=>{
        return{
            ...v,
            checked:this.checkedAll
        }
    }) 
  }
  checkSingle(event){
    const detail = event;
    if(!detail){
        this.checkedAll = false;
    }
  }



}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/printLabelPanel.vue